import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"

import api from "../../../api";
import auth from '../../../auth/';

import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import AgregarCampo from "./AgregarCampo.js"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaFileLink from "../../../components/ParadigmaFileUploader/ParadigmaFileLink.js"
import ParadigmaCKEditor from '../../../components/paradigmaCKEditor/ParadigmaCKEditor.js'

var textareaStyle = {
    minHeight: '300px'
};

class Detail extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.references = [];
        this.state = {
            solicitud_id: null,
            marco_id: null,
            tipo_id: null,
            subtipo_id: null,
            tabs: [],
            activeTab: '0',
            file:{
                 name:null,
                 link:null
            }
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    killEditors(){
         this.references.forEach(
              function(reference) {
                   if(reference.current){
                        reference.current.killEditor();
                   }
              });
    }

    setSelects(data) {
        this.setState({
            solicitud_id: data.solicitud_id,
            marco_id: data.marco_id,
            tipo_id: data.tipo_id,
            subtipo_id: data.subtipo_id,
            tabs: data.campos,
            activeTab: '0',
            file:{
                 name: data.file.name !== undefined && data.file.name !== null ? data.file.name : null,
                 link: data.file.link !== undefined && data.file.link !== null ? api.BASE_URL + data.file.link : null
            }
        });
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    onChangeInput(tabN, input) {
        var i = parseInt(tabN);
        var tabs = this.state.tabs;
        tabs[i].value = input.value;
        this.setState({ tabs: tabs });
    }

    getActiveClass(tabN) {
        if (this.state.activeTab == tabN)
            return "active";
        else
            return "";
    }

    addTab(campo) {
        var tabs = this.state.tabs;
        tabs.push({
            nombre: campo.campo_nombre,
            campo_id: parseInt(campo.campo_id),
            value: "",
            obligatorio: false,
        });
        this.setState({ tabs: tabs });
    }

    removeTab(e, campo_id) {
        e.preventDefault();
        var tabs = this.state.tabs.filter(x => x.campo_id != campo_id);
        this.setState({ tabs: tabs });
    }


    render() {
        var tabhead = [];
        var tabpanel = [];
        this.references = [];
        for (var i = 0; i < this.state.tabs.length; i++) {
             let reference = React.createRef();
             this.references.push(reference);
            var tab = this.state.tabs[i];
            let tabN = i.toString();
            tabhead.push(
                <NavItem key={tabN}>
                    <NavLink className={this.getActiveClass(tabN)} onClick={() => { this.toggle(tabN); }}>
                        {tab.nombre}
                    </NavLink>
                </NavItem>
            );
            tabpanel.push(
                <TabPane tabId={tabN} className="py-0" key={tabN}>
                    <Row>
                        <Col className="col-12 p-0">
                            <Input disabled={true} type="number" name={"tabs[" + tabN + "][id]"} className="p-0 d-none" value={tab.campo_id} onChange={(e) => this.onChangeInput(tabN, e.target)} />
                            <ParadigmaCKEditor
                                 readOnly={true}
                                 id = {"tabs[" + tabN + "][id]"}
                                 ref = {reference}
                                 isInForm={true}
                                 name={"tabs[" + tabN + "][valor]"}
                                 value={tab.value}
                                 onValueChange={ (value) => this.onChangeInput(tabN, value)}
                                 className="GrowingEditor"
                                 filebrowserImageUploadUrl = {api.misc.pictureUploadURL}
                                 fileTools_requestHeaders = { auth.header().headers }
                                 maxLength = {25000}
                            />
                        </Col>
                    </Row>
                </TabPane>
            );
        }


        return (
            <ParadigmaModal
                getUrl={api.proyectos.plandetrabajo.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Plan de Trabajo"}
                buttonTitle={"Ver Plan de Trabajo"}
                buttonIcon={"fa fa-search fa-lg"}
                className = "modalTabulado"
                saveButton={false}
                closeButton={true}
                onClose={() => this.killEditors()}
                onGotData={(data) => this.setSelects(data)}>
                <Row>
                    <Col className="col-5">
                        <Label>Proyecto</Label>
                    </Col>
                    <Col className="col-7">
                        <ParadigmaAsyncSeeker fieldName={"solicitud_id"} url={api.proyectos.solicitudes.select} value={this.state.solicitud_id} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-5">
                        <Label>Tipo de Transferencia</Label>
                    </Col>
                    <Col className="col-7">
                        <ParadigmaAsyncSeeker fieldName={"tipo_id"} url={api.proyectos.config.plan.tipos.select} value={this.state.tipo_id} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-5">
                        <Label>Subtipo de Transferencia</Label>
                    </Col>
                    <Col className="col-7">
                        <ParadigmaAsyncSeeker fieldName={"subtipo_id"} url={api.proyectos.config.plan.subtipos.select + "?tipo=" + (this.state.tipo_id ? this.state.tipo_id : 0)} value={this.state.subtipo_id} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-5">
                        <Label>Modo de Vinculación</Label>
                    </Col>
                    <Col className="col-7">
                        <ParadigmaAsyncSeeker fieldName={"marco_id"} url={api.proyectos.config.plan.marcos.select} value={this.state.marco_id} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>

                <Row className="mt-1">
                    <Col className="col-12">
                        <Label>Requisitos</Label>
                        <div><ParadigmaFileLink message={"Adjunto: "} filename={this.state.file.name} link={this.state.file.link}/></div>
                        <Nav tabs>
                            {tabhead}
                        </Nav>
                        <TabContent activeTab={this.state.activeTab}>
                            {tabpanel}
                        </TabContent>
                    </Col>
                </Row>

                <Row className="mt-1">
                    <Col className="col-12">
                        <Label>Observaciones</Label>
                        <Input type="textarea" name="observaciones" disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento2/Detail.js